import "./module/userAgentChecker.min.js"
import "./module/plugin.js"
import "./module/modal-multi.js"

import Swiper from 'swiper/bundle';
var myswiper = new Swiper('.mv__slider', {
    centeredSlides: true,
    loop: true,
    speed: 3500,
    effect: 'fade',
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    simulateTouch: false,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
});

import objectFitImages from 'object-fit-images';
objectFitImages();

import ModalVideo from 'modal-video'
new ModalVideo('.js-modal-video', {
    youtube: {
        autoplay: 1,
        controls: 1,
        nocookie: true,
        mute: 1,
        loop: 1,
        showinfo: 1
    }
});

(function (d) {
    var config = {
        kitId: 'ugz2vha',
        scriptTimeout: 3000,
        async: true
    },
        h = d.documentElement, t = setTimeout(function () { h.className = h.className.replace(/\bwf-loading\b/g, "") + " wf-inactive"; }, config.scriptTimeout), tk = d.createElement("script"), f = false, s = d.getElementsByTagName("script")[0], a; h.className += " wf-loading"; tk.src = 'https://use.typekit.net/' + config.kitId + '.js'; tk.async = true; tk.onload = tk.onreadystatechange = function () { a = this.readyState; if (f || a && a != "complete" && a != "loaded") return; f = true; clearTimeout(t); try { Typekit.load(config) } catch (e) { } }; s.parentNode.insertBefore(tk, s)
})(document);